import { t } from '@lingui/core/macro';
import { object, string } from 'yup';
export const getSchema = () => {
    const requiredMessage = t({
        message: 'This is a required field.',
        comment: 'Error message for empty required field',
    });
    const emailErrorMessage = t({
        message: 'This must be a valid email.',
        comment: 'Error message for invalid email for eSigning party',
    });
    return object().shape({ email: string().email(emailErrorMessage).required(requiredMessage) });
};
